// helpers/rutaGastos.js
import axios from "axios";

// Base tomada del .env o fallback a producción
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // quita / al final
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- GASTOS ----

// GET: lista
export const getGastos = async () => {
  const { data } = await API.get(p("gastos"), auth());
  // típicamente: { ok, gastos, cantidad }
  return data;
};

// GET: uno por id
export const getGastoById = async (id) => {
  const { data } = await API.get(p(`gastos/${id}`), auth());
  return data;
};

// POST: crear
export const postGasto = async (payload) => {
  const { data } = await API.post(p("gastos"), payload, auth());
  return data;
};

// PUT: actualizar
export const putGasto = async (id, payload) => {
  const { data } = await API.put(p(`gastos/${id}`), payload, auth());
  return data;
};

// DELETE: baja lógica
export const deleteGasto = async (id) => {
  const { data } = await API.delete(p(`gastos/${id}`), auth());
  return data;
};
